export const trackPagination = (analytics = { page: {} }, value = '') => {
    const { category = {} } = analytics.page;
    return {
        event: `pagination - ${value}`,
        eventEffect: 'pagination',
        category: {
            primaryCategory: category.pageType,
            subCategory: category.subCategory1,
        },
        attributes: {
            value,
        },
    };
};
